import { createAction, emptyProps, props } from '@ngrx/store';
import { IdentifiedAssistEvent, ResourceAttendee } from '../models';
import { OrderDescriptor, WebexUserSettingsModel } from '@cue/api';
import {
  CalendarAttendee,
  CalendarEventRecurrence,
  CalendarEventReminder,
  CalendarRecurringMutationScope,
} from '@cue/calendars';

export const eventConfirmed = createAction('[QR] Event confirmed', emptyProps);
export const loadEventsPatched = createAction('[Events] Load', props<{ startFrom?: Date; endFrom?: Date }>());
export const eventsLoaded = createAction('[Events] Loaded', props<{ events: IdentifiedAssistEvent[] }>());

export const crateEventError = createAction('[Events] crate event error', props<{ error?: string }>());

export const deleteEventById = createAction(
  '[Events] Delete By Id',
  props<{
    eventToDeleteId: string;
    icalId: string;
    showAs: string;
    subject: string;
    start: Date;
    end: Date;
    resourceAttendees: ResourceAttendee[];
    mutationScope?: CalendarRecurringMutationScope;
  }>()
);

export const cancelParticipationEventById = createAction(
  '[Events] Cancel participation Event By Id',
  props<{
    eventToCancelParticipationId: string;
    icalId: string;
  }>()
);

export const finishEventById = createAction('[Events] Finish By Id', props<{ eventToFinishId: string }>());

export const even = createAction('[Events] Finish By Id', props<{ eventToDeleteId: string }>());
export const eventDeleteFailed = createAction('[Events] Event Delete Failed', props<{ eventToDeleteId: string }>());

export const createEvent = createAction(
  '[Events] Create',
  props<{
    visibility: 'public' | 'private';
    orders: OrderDescriptor[];
    showAs: { key: string; value: string };
    subject: string;
    text: string;
    start: Date;
    end: Date;
    isAllDay?: boolean;
    resourceAttendees: ResourceAttendee[];
    attendees: {
      isResource: boolean;
      address: string;
      name: string;
      type: 'required' | 'optional';
    }[];
    onlineMeeting?: {
      onlineMeetingProvider: string;
    };
    webexMeeting?: WebexUserSettingsModel;
    reminder: CalendarEventReminder;
    recurrence?: CalendarEventRecurrence | null;
    skipReservationNavigation?: boolean;
    suppressCreatedNotification?: boolean;
  }>()
);

export const notFoundEvent = createAction('[Events] Event not Found');

export const eventCreated = createAction(
  '[Events] Event Created',
  props<{
    id: string;
    iCalUId?: string;
    start: Date;
    end: Date;
    subject: string;
    roomEmails?: string[];
    skipReservationNavigation?: boolean;
    suppressCreatedNotification?: boolean;
  }>()
);

export const eventPatched = createAction(
  '[Events] Event patched',
  props<{
    id: string;
    start: Date;
    end: Date;
  }>()
);

export const eventResponded = createAction(
  '[Events] Event Responded',
  props<{
    id: string;
    attendee: CalendarAttendee;
    showChangeButton: boolean;
  }>()
);
